import { render, staticRenderFns } from "./MembershipPlanCard.vue?vue&type=template&id=5928e11e&scoped=true"
import script from "./MembershipPlanCard.vue?vue&type=script&lang=js"
export * from "./MembershipPlanCard.vue?vue&type=script&lang=js"
import style0 from "./MembershipPlanCard.vue?vue&type=style&index=0&id=5928e11e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928e11e",
  null
  
)

export default component.exports